export default function SearchIcon({ className = 'w-10 h-10', ...props }) {
  return (
    <svg
      className={className}
      viewBox='0 0 51 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.8607 15.4091C17.8979 15.8634 16.3363 17.535 15.882 19.3614C15.7269 20.2154 14.9822 20.8603 14.0916 20.8603C13.0925 20.8603 12.2748 20.0428 12.2748 19.0433C12.2748 17.735 13.3739 15.7453 14.8733 14.2552C16.3452 12.8015 18.0985 11.775 19.5428 11.775C20.5419 11.775 21.36 12.62 21.36 13.6196C21.3601 14.5095 20.715 15.2547 19.8607 15.4091ZM44.8368 39.2313C46.2458 40.6393 46.2458 42.9292 44.8368 44.3372C43.4288 45.7464 41.1387 45.7464 39.7403 44.3372L29.3011 33.9069C26.8664 35.425 23.9949 36.306 20.9058 36.306C12.1201 36.306 5.00631 29.1918 5.00631 20.4061C5.00631 11.6207 12.1201 4.50659 20.9058 4.50659C29.6914 4.50659 36.8053 11.6207 36.8053 20.4061C36.8053 23.4863 35.9234 26.3667 34.4061 28.8014L44.8368 39.2313ZM32.2626 20.4061C32.2626 14.1374 27.1751 9.04929 20.9058 9.04929C14.6365 9.04929 9.5489 14.1374 9.5489 20.4061C9.5489 26.6755 14.6365 31.763 20.9058 31.763C27.1751 31.763 32.2626 26.6755 32.2626 20.4061Z'
        fill='currentColor'
        fillOpacity='0.2'
      />
    </svg>
  )
}
